import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import { PALETTE } from '../../../../styles/constants'
import { getFlexBasis } from '../../../../styles/cssUtils'

const cx = (...c) => c.filter(Boolean).join(' ')

const SPECS_GAP = '8px'

function FeaturesOverview({ titleWithHighlight, specs, specsOnRow }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.title}>
          <SimpleBlockContent
            blocks={titleWithHighlight.text}
            highlight={titleWithHighlight.highlight}
            highlightSx={`color: ${PALETTE.white};`}
            noSpace/>
        </div>
        { renderSpecsList(specs, specsOnRow) }
      </div>
    </div>
  )
}

const renderSpecsList = (specs, specsOnRow) => {
  if (!specs) return null

  return (
    <div className={styles.specsWrapper}>
      <div className={styles.specsRow}>
        { specs.map(spec => renderSingleSpec(spec.title, spec.subtitle, spec.icon, specsOnRow))}
      </div>
    </div>
  )
}

const renderSingleSpec = (title, subtitle, icon, specsOnRow) => {
  const hasTitle = !!title
  const hasSubtitle = !!subtitle
  const specStyle = {
    '--spec-basis-desktop': getFlexBasis((specsOnRow && specsOnRow.forDesktop) || 5, SPECS_GAP),
    '--spec-basis-tablet': getFlexBasis((specsOnRow && specsOnRow.forTablet) || 3, SPECS_GAP),
    '--spec-basis-mobile': getFlexBasis((specsOnRow && specsOnRow.forMobile) || 2, SPECS_GAP),
  }
  return (
    <div
      className={cx(styles.spec, hasTitle && styles.specHasTitle, hasTitle && hasSubtitle && styles.specHasTitleAndSubtitle)}
      style={specStyle}
    >
      {/* eslint-disable-next-line local-rules/img-requires-dimensions -- faithful port of the former (empty) styled.img Icon: no reserved box existed pre-migration; sizing is intrinsic/CSS-driven, adding fabricated dimensions would alter layout (#89) */}
      {/* alt="" on purpose: the icon is decorative — the spec title/subtitle next
          to it already carries the meaning, so a described icon would just make
          screen readers read every spec twice. */}
      {icon && <img className={styles.icon} src={icon?.src} alt=""/>}{/* task #67: styled img src from descriptor */}
      <div className={styles.specText}>
        <div className={styles.specTitle}>
          <SimpleBlockContent blocks={title} noSpace/>
        </div>
        <div className={styles.specSubtitle}>
          <SimpleBlockContent blocks={subtitle} noSpace/>
        </div>
      </div>
    </div>
  )
}

export default FeaturesOverview
